import React, { useEffect } from 'react';
import './Overview.css';
import { Button, Row, Col } from 'react-bootstrap';
import Right_mark from "../../assets/images/right_mark.png";
import create_portal_img from '../../assets/images/create_portal_img.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**Overview Module */
export default function Overview() {
  const navigate = useNavigate();

  const data = [
    { feature: 'Price per page', basic: '$0.15', advanced: '$0.50' },
    { feature: 'Access Control', basicImage: Right_mark, advancedImage: Right_mark },
    { feature: 'Pretrained Google NMT', basicImage: Right_mark, advancedImage: Right_mark },
    { feature: 'Custom Glossaries', basicImage: Right_mark, advancedImage: Right_mark },
    // { feature: 'Custom AutoML models', basic: '', advancedImage: Right_mark },
    // { feature: 'Translation memories', basic: '', advancedImage: Right_mark },
    // { feature: 'Post-editing tools', basic: '', advancedImage: Right_mark }
  ];
  const { isAdmin } = useAuth();

  useEffect(() => {
    document.title = 'Overview - Acumen Translation Hub';
  }, []);

  return (
    <div className="d-flex overflow-auto h-100 ">
      <div className="w-100">
        <div className="w-100 header border-bottom position-sticky top-0 bg-white py-2">
          <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Overview</h2>
        </div>
        <Row className="my-4 mb-5 mx-3 text-start">
          <Col >
            <h3 className="fs-5 fw_600 text-start">Get Started With Acumen Translation Hub</h3>
            <p className="fs-6  text-start">Acumen Translation Hub provides self-service translations in 135 languages for organizations that require real-time document translations.</p>
            <p className='text-danger pt-2'><span className='fs_14 fw_600'>DISCLAIMER :</span>  At the end of the retention period, all data associated with the translation job will be deleted on the portal.
              Users are advised to back up their files before the retention period expires to avoid any risk of data loss.</p>
            {isAdmin &&
              <Button variant="primary" onClick={() => navigate("/portal-create")} className='mt-4'>CREATE PORTAL</Button>
            }
          </Col>
          {/* <Col md={4} className="text-center d-none d-lg-inline">
            <img src={create_portal_img} className="img-fluid  w-25" alt="Create Portal" />
          </Col> */}
        </Row>
        <div className='full_card text-start mx-3'>
          <h3 className="fs-5 fw_600">How it works</h3>
          <Row className="text-start  How_it_card mb-5">

            <Col classname="How_it_card_items">
              <div className='d-flex gap-4 mt-3'>
                <img src="https://www.gstatic.com/pantheon/images/cloud_ai/translationhub/dashboard/portal.svg" className="img-fluid mb-2" alt="Create Portal" />
                <h4 className="fs-6 fw-normal">Create a portal</h4>
              </div>
              <div className='d-flex gap-4'>
                <img src="https://www.gstatic.com/pantheon/images/cloud_ai/translationhub/dashboard/user.svg" className="img-fluid mb-2" alt="Invite Users" />
                <h4 className="fs-6 fw-normal">Invite users</h4>
              </div>
              <div className='d-flex gap-4'>
                <img src="https://www.gstatic.com/pantheon/images/cloud_ai/translationhub/dashboard/resource.svg" className="img-fluid mb-2" alt="Use Custom Translation Resources" />
                <h4 className="fs-6 fw-normal">Use custom translation resources</h4>
              </div>
            </Col>

          </Row>
          {/* <h3 className="fs-5 fw_600">Portal Price Plan</h3> */}
          {/* <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Basic</th>
                  <th>Advanced</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.feature}</td>
                    <td>{item.basicImage ? <img src={item.basicImage} alt="Basic feature" /> : item.basic}</td>
                    <td>{item.advancedImage ? <img src={item.advancedImage} alt="Advanced feature" /> : item.advanced}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
        </div>
      </div>
    </div >
  );
}
